<template>
  <div id="app"
    class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="br" page="gb" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section class="hero">
              <div class="hero__content">
                <div class="hero__panel">
                  <div class="hero__header">
                    <h1 class="hero__title">Download de Vídeo do Instagram</h1>
                    <p class="hero__subtitle">Baixe Vídeo do Instagram, Foto, Reels, Stories Online</p>
                    <p class="hero__hint">COLE O LINK E CLIQUE NO BOTÃO DE DOWNLOAD</p>
                  </div>
                  <form class="hero__form" @submit.prevent="downloadClick">
                    <input v-model="pasteUrl" class="hero__input" type="text" placeholder="COLE A URL"
                      aria-label="Cole o link do Instagram" />
                    <button class="hero__button" type="submit">
                      <!-- <span class="hero__button-icon"></span> -->
                      <img style="width: 20px; height: 20px;" src="../assets/Download.png" alt="Download"></img>
                      Download
                    </button>
                  </form>
                </div>
              </div>
            </section>

            <div class="markdown-content">
              <h2>Use o <strong>SnapInsta</strong> para Baixar Vídeos e Fotos do Instagram</h2>

              <p>No SnapInsta, entendemos a importância de preservar seus momentos preciosos do Instagram. É por isso que
                criamos uma plataforma de ponta que permite baixar facilmente reels, vídeos, stories e fotos do Instagram
                com apenas alguns cliques. Seja você um usuário ávido de mídia social, um criador de conteúdo ou simplesmente
                alguém que adora capturar memórias, o SnapsInsta é seu destino para todas as suas necessidades de download.
              </p>

              <h2><strong>Por que escolher o SnapsInsta?</strong></h2>

              <ul>
                <li><strong>Fácil de usar:</strong> Nossa interface intuitiva torna o download de conteúdo do Instagram uma
                  tarefa simples. Basta colar o link e deixar o resto conosco.</li>
                <li><strong>Opções abrangentes de download:</strong> De reels a stories, vídeos a fotos, o SnapsInsta
                  oferece uma ampla gama de opções de download para atender às suas preferências.</li>
                <li><strong>Rápido e seguro:</strong> Priorizamos velocidade e segurança, garantindo que seus downloads sejam
                  processados rapidamente e seus dados permaneçam protegidos o tempo todo.</li>
                <li><strong>Experiência perfeita:</strong> Seja você um usuário experiente em tecnologia ou um iniciante, o
                  SnapsInsta oferece uma experiência de download perfeita que qualquer pessoa pode desfrutar.</li>
              </ul>

              <p>O aplicativo <a href="https://snapsinsta.com/">SnapInsta</a> é um site amigável projetado para atender às
                necessidades dos usuários do Instagram que desejam baixar conteúdo de mídia da plataforma. Seja você um
                Instagrammer ávido, criador de conteúdo ou simplesmente alguém que adora salvar momentos memoráveis, o
                SnapsInsta simplifica o processo de download de conteúdo com apenas alguns cliques.</p>

              <div style="position: relative;">
                <img src="../assets/snapinsta.webp" alt="SnapInsta">
                <button class="hero__button"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);z-index: 1000;">Download</button>
                </img>
              </div>




              <h2>Principais Recursos do SnapInsta Downloader</h2>

              <h3><strong>Downloader de Reels:</strong></h3>

              <p>Com o aumento do conteúdo de vídeo de formato curto no Instagram, os reels se tornaram imensamente
                populares. O SnapsInsta permite que você baixe seus reels favoritos diretamente para seu dispositivo,
                permitindo que você os desfrute offline ou os compartilhe com amigos.</p>

              <h3><strong>Downloader de Vídeo:</strong></h3>

              <p>Seja um tutorial, um clipe engraçado ou um vídeo de viagem hipnotizante, o SnapsInsta permite que você baixe
                qualquer vídeo do Instagram sem complicações. Simplesmente copie o link do vídeo que deseja baixar e cole-o na
                interface intuitiva do SnapsInsta – o resto é feito por nós.</p>

              <h3><strong>Downloader de Story e Foto:</strong></h3>

              <p>As stories e fotos do Instagram frequentemente capturam momentos fugazes que queremos guardar para sempre.
                Com o SnapsInsta, você pode salvar esses momentos baixando stories e fotos sem esforço. Seja uma paisagem
                deslumbrante, uma refeição deliciosa ou um selfie comovente, você pode preservar essas memórias com
                facilidade.</p>

              <h3><strong>Interface amigável:</strong></h3>

              <p>O SnapsInsta apresenta uma interface limpa e intuitiva que torna o download de conteúdo do Instagram uma
                tarefa simples. Seja você um usuário experiente em tecnologia ou um iniciante, encontrará o site fácil de
                navegar, garantindo uma experiência de download perfeita toda vez.</p>

              <h3><strong>Rápido e seguro:</strong></h3>

              <p>O SnapsInsta prioriza velocidade e segurança, garantindo que seus downloads sejam processados rapidamente e
                com segurança. Você pode ter certeza de que seus dados permanecerão privados e protegidos durante todo o
                processo de download.</p>

              <h2><strong>Como usar o SnapInsta para baixar vídeos do Instagram:</strong></h2>

              <p>Usar o SnapInsta é simples e direto. Veja como funciona:</p>

              <ol>
                <li><strong>Copie o link:</strong> Navegue até o reel, vídeo, story ou foto do Instagram que deseja baixar e
                  copie seu link.</li>
                <li><strong>Cole o link:</strong> Visite <a href="https://snapsinsta.com/">snapsinsta.com</a> e cole o link
                  copiado no campo designado.</li>
                <li><strong>Download:</strong> Clique no botão de download e o SnapsInsta processará o link, permitindo que
                  você baixe o conteúdo desejado para seu dispositivo.</li>
                <li><strong>Aproveite:</strong> Depois que o download for concluído, você pode desfrutar do conteúdo baixado
                  offline ou compartilhá-lo com amigos e familiares.</li>
              </ol>

              <h2>Perguntas frequentes sobre o Downloader do Instagram</h2>

              <h3>Como baixar vídeo do Instagram em alta qualidade a partir do link?</h3>

              <p>Nossa ferramenta permite que você baixe vídeos do Instagram simplesmente copiando e colando o URL do vídeo no
                campo fornecido em nosso site. Clique no botão de download e o vídeo será salvo em seu dispositivo para
                visualização offline.</p>

              <h3>Posso baixar vídeos privados do Instagram?</h3>

              <p>Não, nossa ferramenta suporta apenas o download de vídeos de contas públicas do Instagram. Os vídeos
                privados são restritos aos proprietários da conta e seus seguidores aprovados.</p>

              <h3>Preciso criar uma conta para usar a Ferramenta de Download de Vídeo do Instagram?</h3>

              <p>Não, você pode usar nossa ferramenta sem criar uma conta. Não exigimos nenhuma informação pessoal sua.</p>

              <h3>A Ferramenta de Download de Vídeo do Instagram é gratuita?</h3>

              <p>Sim, nossa ferramenta é completamente gratuita. Você pode baixar vídeos do Instagram sem nenhum custo ou
                taxa de assinatura.</p>

              <h3>A Ferramenta de Download de Vídeo do Instagram funciona em todos os dispositivos?</h3>

              <p>Sim, nosso site é acessível a partir de vários dispositivos, incluindo computadores desktop, laptops,
                smartphones e tablets. Você pode usar nossa ferramenta em qualquer dispositivo com conexão à internet e um
                navegador da web.</p>

              <h3>Como você garante a privacidade e segurança dos dados do usuário?</h3>

              <p>Priorizamos a privacidade do usuário e não coletamos nenhuma informação pessoal durante o processo de download
                do vídeo. Também tomamos medidas para proteger a segurança de nosso site e atualizamos regularmente nossos
                protocolos de segurança.</p>

              <h3>Posso baixar vários vídeos de uma vez?</h3>

              <p>Nossa ferramenta é projetada para baixar um vídeo por vez. Se você deseja baixar vários vídeos, pode fazê-lo
                consecutivamente repetindo o processo para cada vídeo.</p>

              <h3>Existem restrições no uso de vídeos baixados?</h3>

              <p>Depois de baixar um vídeo, você é responsável por seu uso. Certifique-se de cumprir as leis de direitos
                autorais e os termos de uso estabelecidos pelo proprietário do vídeo. Não assumimos nenhuma responsabilidade
                pelo uso indevido ou não autorizado de vídeos baixados.</p>

              <h3>É legal baixar vídeos do Instagram?</h3>

              <p>Baixar vídeos do Instagram para uso pessoal geralmente é permitido, desde que você tenha as permissões e
                direitos necessários para o conteúdo. No entanto, é essencial respeitar as leis de direitos autorais e os
                termos de uso dos vídeos que você baixa.</p>

              <h3>Com que frequência a Ferramenta de Download de Vídeo do Instagram é atualizada?</h3>

              <p>Nos esforçamos para manter nossa ferramenta atualizada e funcional com as últimas mudanças e atualizações do
                Instagram. No entanto, observe que ajustes ocasionais podem ser necessários devido às mudanças na plataforma do
                Instagram.</p>
            </div>
          </main>
        </div>
      </div>
    </div>

    <!-- <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    GB WhatsApp Download(v18.70)
  </div> -->
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';

export default {
  name: 'Br',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      pasteUrl: '',
      showapk: false,
      showTableOfContents: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'br',
    };
  },
  computed: {
    downloadURL() {
      if (typeof window === 'undefined') {
        return '/gbwhatsapp-apk-download';
      } else {
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadClick() {
      this.$router.push({
        name: 'br-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
h2,h3 {
  color: #186dff !important;
  strong{
    color: #186dff !important;
  }
  
}

.markdown-content {
  padding: 48px 40px;
  line-height: 1.75;
  margin: 0 auto;
  max-width: 1000px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  color: #4a5568;
  font-size: 16px;
}

.markdown-content h1 {
  font-size: 2.25em;
  margin: 0 0 24px 0;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
  color: #1a202c;
  font-weight: 700;
  line-height: 1.3;
}

.markdown-content h2 {
  font-size: 1.75em;
  margin: 48px 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  line-height: 1.4;
}

.markdown-content h3 {
  font-size: 1.375em;
  margin: 36px 0 16px 0;
  color: #2d3748;
  font-weight: 600;
  line-height: 1.4;
}

.markdown-content h4 {
  font-size: 1.125em;
  margin: 28px 0 12px 0;
  color: #2d3748;
  font-weight: 600;
}

.markdown-content p {
  margin: 0 0 20px 0;
  color: #4a5568;
  line-height: 1.75;
}

.markdown-content ul,
.markdown-content ol {
  margin: 20px 0;
  padding-left: 28px;
  color: #4a5568;
}

.markdown-content li {
  margin: 10px 0;
  line-height: 1.75;
}

.markdown-content li strong {
  color: #2d3748;
  font-weight: 600;
}

.markdown-content blockquote {
  border-left: 3px solid #cbd5e0;
  padding: 16px 20px;
  margin: 24px 0;
  background: #f7fafc;
  color: #4a5568;
  border-radius: 0 6px 6px 0;
  font-style: italic;
}

.markdown-content hr {
  margin: 40px 0;
  border: none;
  border-top: 1px solid #e2e8f0;
  height: 0;
}

.markdown-content pre {
  background: #f7fafc;
  padding: 16px;
  border-radius: 6px;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  margin: 20px 0;
}

.markdown-content code {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 0.9em;
  background: #f7fafc;
  padding: 3px 8px;
  border-radius: 4px;
  color: #e53e3e;
  border: 1px solid #e2e8f0;
}

.markdown-content pre code {
  background: transparent;
  padding: 0;
  border: none;
  color: #2d3748;
}

.markdown-content img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 32px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.markdown-content img:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.markdown-content > div {
  margin: 32px 0;
}

.markdown-content a {
  color: #3182ce;
  text-decoration: none;
  transition: color 0.2s ease;
  font-weight: 500;
}

.markdown-content a:hover {
  color: #2c5aa0;
  text-decoration: underline;
}

.markdown-content strong {
  font-weight: 600;
  color: #2d3748;
}

.markdown-content em {
  font-style: italic;
  color: #4a5568;
}

.markdown-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 32px 0;
  font-size: 0.95em;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.markdown-content th,
.markdown-content td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.markdown-content th {
  background-color: #f7fafc;
  font-weight: 600;
  color: #2d3748;
  text-transform: uppercase;
  font-size: 0.875em;
  letter-spacing: 0.5px;
}

.markdown-content tr:last-child td {
  border-bottom: none;
}

.markdown-content tr:nth-child(even) {
  background-color: #fafbfc;
}

.markdown-content tr:hover {
  background-color: #f7fafc;
  transition: background-color 0.2s ease;
}

@media (max-width: 768px) {
  .markdown-content {
    padding: 32px 24px;
    font-size: 15px;
    border-radius: 8px;
  }

  .markdown-content h1 {
    font-size: 1.875em;
    margin-bottom: 20px;
  }

  .markdown-content h2 {
    font-size: 1.5em;
    margin-top: 36px;
  }

  .markdown-content h3 {
    font-size: 1.25em;
    margin-top: 28px;
  }

  .markdown-content ul,
  .markdown-content ol {
    padding-left: 24px;
  }
}

.hero {
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 16px 120px;
  background: linear-gradient(135deg, #2e2bf3 0%, #ff38c9 100%);
}

.hero__content {
  width: 100%;
  max-width: 1100px;
  display: flex;
  justify-content: center;
}

.hero__panel {
  width: 100%;
  max-width: 950px;
  padding: 32px 40px 44px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.4) 100%);
  text-align: center;
}

.hero__header {
  margin-bottom: 26px;
}

.hero__title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}

.hero__subtitle {
  margin: 12px 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.hero__hint {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: #fff;
  text-transform: uppercase;
}

.hero__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.hero__input {
  width: 100%;
  max-width: 880px;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
  font-size: 14px;
  color: #333;
}

.hero__input::placeholder {
  color: #777;
}

.hero__button {
  /* background: url('../assets/snapinsta.webp'); */
  background-size: cover;
  /* 可选：适配容器 */
  background-repeat: no-repeat;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 28px;
  height: 44px;
  width: 200px;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0088ff 0%, #0067e0 100%);
  box-shadow: 0 12px 28px rgba(232, 236, 241, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.hero__button:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(190, 213, 240, 0.4);
}

.hero__button:active {
  transform: translateY(0);
  box-shadow: 0 10px 20px rgba(190, 217, 248, 0.32);
}

.hero__button-icon {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid #fff;
}

@media (max-width: 768px) {
  .hero {
    padding: 60px 16px 80px;
  }

  .hero__panel {
    padding: 28px 24px 38px;
  }

  .hero__title {
    font-size: 24px;
  }

  .hero__subtitle {
    font-size: 15px;
  }
}
</style>

